export default __webpack_public_path__ + "b868c96da7b93ef860ba46dee48731aa.png";